import React, { useEffect } from 'react'
import { Button } from '@material-ui/core'
import { useAppDispatch, useAppSelector } from '../../useStore';
import moment from "moment"
import { createjob, reset } from '../../features/Job/jobSlice';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { Spinners } from '../../components/TableOptions';
import { getallReguser } from '../../features/Registration/registrationSlice';


const Summary = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const { data } = useAppSelector((state: { auth: any; }) => state.auth)
	const {
		isErrorcreate,
		isSuccesscreate,
		isLoadingcreate,
		messagecreate } = useAppSelector((state: { job: any; }) => state.job)

	const { dataAll } = useAppSelector(
		(state: { registration: any }) => state.registration
	);

	useEffect(() => {
		dispatch(getallReguser());
	}, [dispatch]);


	useEffect(() => {
		if (isErrorcreate) {
			swal({
				title: "error",
				text: messagecreate,
				// @ts-ignore
				icon: "error"
			})
		} else if (isSuccesscreate) {
			swal({
				title: "success",
				text: "Job have been created!",
				// @ts-ignore
				icon: "success"
			}).then(okay => {
				if (okay) {
					navigate('/jobs')
				}
			});
		}
		dispatch(reset())
	}, [dispatch, isErrorcreate, isSuccesscreate, messagecreate, navigate])


	const onCreateJob = () => {
		// @ts-ignore
		dispatch(createjob(data));
	}



	const recruiter = dataAll?.data?.filter((obj: any) => {
		return obj?.id === data?.recruiterTagged
	})
	const hiringmanager = dataAll?.data?.filter((obj: any) => {
		return obj?.id === data?.hiringManager
	})




	return (
		<div  >
			<div className='summary-container'>
				<div>
					<div className='summary-container-title'>Job Details</div>
					<div className='summary-container-title-sub'>Job Details</div>
				</div>
				<div className='summary-main'>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Job Profile</h6>
							<p className='jobSummary-effect'>{data?.jobProfile} </p>

						</div>
						<div>
							<h6 className='summary-job-title'>Job Function</h6>
							<p className='jobSummary-effect'>{data?.jobFunction}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Education</h6>
							<p className='jobSummary-effect'>{data?.education}</p>
						</div>
					</div>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Team</h6>
							<p className='jobSummary-effect'>{data?.team}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Employment Type</h6>
							<p className='jobSummary-effect'>{data?.employmentType}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Experience Level</h6>
							<p className='jobSummary-effect'>{data?.experienceLevel}</p>
						</div>
					</div>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Location</h6>
							<p className='jobSummary-effect'>{data?.jobLocation}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Job Workplace Type</h6>
							<p className='jobSummary-effect'>{data?.workplaceType}</p>
						</div>
						<div>

						</div>
						<div>

						</div>
					</div>
				</div>
			</div>
			{/* Total Work Experience */}
			<div className='summary-container'>
				<div>
					<div className='summary-container-title'>Total Work Experience</div>
					<div className='summary-container-title-sub'>Job description</div>
				</div>
				<div className='summary-main'>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Qualifications</h6>
							<p className='jobSummary-effect'>{data?.qualifications}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Good to have skills</h6>
							{data?.goodHaveSkills?.map((item: any, i: any) =>
							(<ul>
								<li key={i}>
									{item}
								</li>
							</ul>
							))}
						</div>
						<div>
							<h6 className='summary-job-title'>Employment Type</h6>
							<p className='jobSummary-effect'>{data?.employmentType}</p>
						</div>
					</div>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Job Role</h6>
							<p className='jobSummary-effect'>{data?.jobRole}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Must have skills</h6>
							{data?.mustHaveSkills?.map((item: any, i: any) =>
							(<ul>
								<li key={i}>
									{item}
								</li>
							</ul>
							))}
						</div>
						<div>
						</div>
					</div>
				</div>
			</div>

			{/* Total Work Experience */}
			<div className='summary-container'>
				<div>
					<div className='summary-container-title'>Total Work Experience</div>
					<div className='summary-container-title-sub'>Job Details</div>
				</div>
				<div className='summary-main'>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Accessibility</h6>
							<p className='jobSummary-effect'>Public</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Number of Openings</h6>
							<p className='jobSummary-effect'>{data?.numberOfOpenings}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Hiring Manager</h6>
							<p className='jobSummary-effect'>{hiringmanager[0]?.firstName === undefined ? <span style={{ color: 'red' }}>No Hiring Manager</span> : hiringmanager[0]?.firstName + ' ' + hiringmanager[0]?.LastName === undefined ? <span style={{ color: 'red' }}>No Hiring Manager</span> : hiringmanager[0]?.firstName + ' ' + hiringmanager[0]?.LastName}</p>
						</div>
					</div>
					<div className='summary-container-title-sub-children'>
						<div>
							<h6 className='summary-job-title'>Recruiter Tagged</h6>
							<p className='jobSummary-effect'>{recruiter[0]?.firstName === undefined ? <span style={{ color: 'red' }}>No Recruiter Tagged</span> : recruiter[0]?.firstName + ' ' + recruiter[0]?.LastName === undefined ? <span style={{ color: 'red' }}>No Recruiter Tagged</span> : recruiter[0]?.firstName + ' ' + recruiter[0]?.LastName}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Start Date</h6>
							<p className='jobSummary-effect'> {moment(data?.openingDate).format("MMM Do YY") === "Invalid date" ? <span style={{ color: 'red' }}>No Start Date</span> : moment(data?.openingDate).format("MMM Do YY")}</p>
						</div>
						<div>
							<h6 className='summary-job-title'>Closing Date</h6>
							<p className='jobSummary-effect'> {moment(data?.expiryDate).format("MMM Do YY") === "Invalid date" ? <span style={{ color: 'red' }}>No Closing Date</span> : moment(data?.expiryDate).format("MMM Do YY")}</p>
						</div>
					</div>
				</div>
			</div>

			{/* Total Work Experience */}
			<div className='summary-container'>
				<div>
					<div className='summary-container-title'>Candidate Fields</div>
					<div className='summary-container-title-sub'>Profile Info</div>
				</div>
				<div className='summary-main'>
					<div className='summary-main-flag-option1'>
						<p className='jobSummary-effect'>System fields</p>
						<p className='jobSummary-effect'>Required </p>
					</div>
					<div className='summary-main-flag-option' id={data?.makeJobPrivate === true ? "summary-main-p-green-div" : "summary-main-p-red-div"} >
						<p className='jobSummary-effect'>Make Job Private</p>
						<p id={data?.makeJobPrivate === true ? "summary-main-p-green" : "summary-main-p-red"}  >{data?.makeJobPrivate === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.firstname === true ? "summary-main-p-green-div" : "summary-main-p-red-div"} >
						<p className='jobSummary-effect'>First Name</p>
						<p id={data?.firstname === true ? "summary-main-p-green" : "summary-main-p-red"}  >{data?.firstname === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.lastname === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Last Name </p>
						<p id={data?.lastname === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.lastname === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.email === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Email</p>
						<p id={data?.email === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.email === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.resume === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Resume</p>
						<p id={data?.resume === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.resume === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.linkedinUrl === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>LinkedIn Url  </p>
						<p id={data?.linkedinUrl === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.linkedinUrl === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.Phone === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Phone</p>
						<p id={data?.Phone === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.Phone === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.currentSalary === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Current Salary</p>
						<p id={data?.currentSalary === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.currentSalary === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.expectedSalary === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Expected Salary </p>
						<p id={data?.expectedSalary === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.expectedSalary === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.totalWorkExperience === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Total Work Experience </p>
						<p id={data?.totalWorkExperience === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.totalWorkExperience === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.relevantWorkExperience === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Relevant Work Experience  </p>
						<p id={data?.relevantWorkExperience === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.relevantWorkExperience === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.reasonForJobChange === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Reason For Job Change</p>
						<p id={data?.reasonForJobChange === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.reasonForJobChange === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.noticePeriod === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Notice Period (in days)</p>
						<p id={data?.noticePeriod === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.noticePeriod === true ? 'Yes' : 'No'}</p>
					</div>
					<div className='summary-main-flag-option' id={data?.location === true ? "summary-main-p-green-div" : "summary-main-p-red-div"}>
						<p className='jobSummary-effect'>Location</p>
						<p id={data?.location === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.location === true ? 'Yes' : 'No'}</p>
					</div>

					<div>
						<h6 className='summary-job-title'>Education Details</h6>
						<div className='Education-Details-title'>
							<div>
								<p className='jobSummary-effect'>System fields
								</p>
								<p className='jobSummary-effect'>Education Details</p>
							</div>
							<div>
								<p className='jobSummary-effect'>{data?.educationDetails === true ? 'Required *' : 'Not Required *'}
								</p>
								<p id={data?.educationDetails === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.educationDetails === true ? 'Yes' : 'No'}</p>
							</div>
						</div>
					</div>
					<div>
						<h6 className='summary-job-title'>Additional Details</h6>
						<div className='Education-Details-title'>
							<div>
								<p className='jobSummary-effect'>System fields
								</p>
								<p className='jobSummary-effect'>Additional Details</p>
							</div>
							<div>
								<p className='jobSummary-effect'>{data?.additionalDetails === true ? 'Required *' : 'Not Required *'}
								</p>
								<p id={data?.additionalDetails === true ? "summary-main-p-green" : "summary-main-p-red"} > {data?.additionalDetails === true ? 'Yes' : 'No'}</p>
							</div>
						</div>
					</div>

					<div>
						<h6 className='summary-job-title'>Work Experience</h6>
						<div className='Education-Details-title'>
							<div>
								<p >System fields
								</p>
								<p className='jobSummary-effect'>Work Experience</p>
							</div>
							<div>
								<p className='jobSummary-effect'>{data?.workExperience === true ? 'Required *' : 'Not Required *'}	</p>
								<p id={data?.workExperience === true ? "summary-main-p-green" : "summary-main-p-red"}>{data?.workExperience === true ? 'Yes' : 'No'}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='summary-bottom-btn-container' >
				{isSuccesscreate ? "" : <Button variant="contained" className='summary-bottom-btn' onClick={onCreateJob}>
					{isLoadingcreate ? <Spinners size={"sm"} /> : 'Create Job'}
				</Button>}
			</div>
		</div >
	)
}

export default Summary

